export function localStorageSetBoolean(key: string, value: boolean) {
    localStorage.setItem(key, value.toString());
}
export function localStorageGetBoolean(key: string, defaultValue: boolean): boolean {
    const readValue = localStorage.getItem(key);
    if (!readValue) return defaultValue;
    if (readValue === 'true') return true;
    if (readValue === 'false') return false
    return defaultValue;
}